import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Box, InputLabel, Stack, TextField } from '@mui/material';
import { Controller, FieldValues } from 'react-hook-form';
import PhoneInput from 'react-phone-input-2';

import { BaseInputProps } from './GetFormInput';

export function FormPhone<T extends FieldValues>({
    control,
    disabled,
    helperText,
    iconType,
    label,
    required,
    small,
    validation,
    value,
}: Readonly<BaseInputProps<T>>) {
    return (
        <Controller
            control={control}
            name={value}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <Box>
                    <InputLabel sx={{ color: 'black', fontWeight: 'medium', mb: 0.5 }}>{label}</InputLabel>
                    <Stack direction="row">
                        <Stack
                            direction="row"
                            sx={{
                                alignItems: 'center',
                                border: '1px solid',
                                borderBottomLeftRadius: '4px',
                                borderColor: '#C9C9C9',
                                borderRight: 'none',
                                borderTopLeftRadius: '4px',
                                justifyContent: 'center',
                                padding: '12px',
                            }}
                        >
                            <WhatsAppIcon
                                sx={{
                                    color: '#25D366',
                                    height: 30,
                                    width: 30,
                                }}
                            />
                        </Stack>
                        <PhoneInput
                            autoFormat={false}
                            buttonStyle={{ borderRadius: 0 }}
                            country="fi"
                            disabled={disabled}
                            inputStyle={{
                                height: small ? '36px' : '56px',
                                width: '100%',
                            }}
                            onChange={(phone) => {
                                const formattedPhone = phone.length > 0 ? `https://wa.me/${phone}` : phone;
                                if (iconType === 'whatsapp') {
                                    onChange(formattedPhone);
                                } else {
                                    onChange(phone);
                                }
                            }}
                            placeholder="+358 12 345 67 89"
                            preferredCountries={['fi', 'gb']}
                            specialLabel=""
                            value={value}
                        />
                    </Stack>
                    <TextField error={!!error} helperText={error?.message || helperText} sx={{ display: 'none' }} />
                </Box>
            )}
            rules={{
                required: required ? `${label ?? value} cannot be empty` : false,
                validate: (value) => {
                    if (value) {
                        const result = validation?.safeParse(value);
                        return result?.success ? true : result?.error.errors[0]?.message;
                    }
                },
            }}
        />
    );
}
